import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ACLService } from "@delon/acl";
import { OrderV2Service } from "@root/router/order-v2/order-v2.service";
import { Router } from "@angular/router";
import { NzMessageService } from "ng-zorro-antd/message";
import { TranslateService } from "@root/shared/service/translate.service";
import { PlatformType } from "@root/config";

@Component({
  selector: "host-widget-extra-block",
  templateUrl: "./extra-block.component.html",
  styleUrls: ["./extra-block.component.scss"],
})
export class WidgetExtraBlockComponent implements OnInit {
  _orderDetail;
  @Input()
  get orderDetail() {
    return this._orderDetail;
  }
  set orderDetail(value) {
    this._orderDetail = value;

    this.creatorId = value?.creator_operator_id;
  }

  @Output() onCompleteEdit = new EventEmitter();

  optionsOfSubaccount = [];
  creatorId;
  get isSubaccount() {
    return this.acl.can({ role: ["slave"] });
  }

  get isDirectBooking() {
    return this.orderDetail?.thirdparty_type === PlatformType.DirectBooking;
  }

  constructor(
    private acl: ACLService,
    private orderSrv: OrderV2Service,
    private router: Router,
    private msg: NzMessageService,
    private t: TranslateService,
  ) {}
  ngOnInit() {
    this.initSubaccountOptions();
  }

  private initSubaccountOptions() {
    const params = {
      page: "1",
      page_size: "1000",
      format: "reservation_creator",
    };
    this.orderSrv.fetchSubaccountList(params).subscribe((rst) => {
      this.optionsOfSubaccount = rst?.data.list?.map((s) => ({
        label: s.creator_name,
        value: s.operator_id,
      }));
    });
  }

  onCreatorChange() {
    this.requestSetCreator();
  }

  onRereadReservation() {
    this.requestRereadReservation();
  }

  toLogPage(logType, code) {
    this.router.navigate(["/app/system"], {
      queryParams: { tab: 1, logType, code },
    });
  }

  private requestSetCreator() {
    const creator = this.optionsOfSubaccount.find((a) => a.value === this.creatorId);
    if (!creator) {
      return;
    }
    const params = {
      reservation_code: this.orderDetail.code,
      operator_id: creator.value,
      creator_name: creator.label,
      // ...creator,
    };
    this.orderSrv.requestSetCreator(params).subscribe((rst) => {
      if (rst.error_code === 0) {
        this.onCompleteEdit.emit();
        // this.messageService.success('设置成功');
        this.msg.success(this.t.t("reservation.detail.creator.toast.set_success"));
      }
    });
  }

  private requestRereadReservation() {
    this.orderSrv
      .refreshReservationOrder({
        reservation_order_code: this.orderDetail?.reservation_order.code,
      })
      .subscribe((res) => {
        if (res.error_code === 0) {
          // 正在重新读取订单数据
          this.msg.warning(this.t.t("warning.reading_order_detail"));
        }
      });
  }
}
